module.exports = __webpack_public_path__ + "img/ALSH_SEJOUR_AUTOMNE.7403a4b1.svg";